import { ReactElement, useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination, Review } from '../../Molecules'
import { ReviewsProps } from './props'
import { ReviewsContainer, StyledReviews } from './styles'

const Reviews = ({ perPage = 3, reviews }: ReviewsProps): ReactElement => {
    const [showReviews, setShowReviews] = useState(reviews.slice(0, perPage))

    useEffect(() => {
        setShowReviews(reviews.slice(0, perPage))
    }, [perPage, reviews])

    const onPageChange = useCallback(
        (selectedPage: number) => {
            setShowReviews(
                reviews.slice(
                    (selectedPage - 1) * perPage,
                    selectedPage * perPage
                )
            )
        },
        [perPage, reviews]
    )

    const pageCount = useMemo(
        () => Math.ceil(reviews.length / perPage),
        [perPage, reviews.length]
    )

    const shownReviews = useMemo(
        () =>
            showReviews.map((review, key) => (
                <Review
                    comment={review.comment}
                    date={review.date}
                    key={key}
                    name={review.name}
                    rating={review.rating}
                />
            )),
        [showReviews]
    )

    return (
        <StyledReviews>
            <ReviewsContainer
                css={{
                    '@desktop': {
                        gridTemplateColumns: `repeat(${perPage}, 1fr)`,
                    },
                }}
            >
                {shownReviews}
            </ReviewsContainer>
            {perPage < reviews.length && (
                <Pagination onPageChange={onPageChange} pageCount={pageCount} />
            )}
        </StyledReviews>
    )
}

export default Reviews

export { StyledReviews }
